<ng-container *ngIf="ready == false">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>

<ng-container *ngIf="ready">

  <div class="dlg-hdr">
    <div class="dlg-hdr__title">
      <div class="dlg-hdr__icon-wrap"><mat-icon>payment</mat-icon></div>
      <div>
        <span>Cobro cuotas</span>
      </div>
    </div>
    <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dlg-body">

    <div class="row" *ngIf="depositSaved === false">
      <div class="col-4">
        <mat-form-field class="w-100 mb-2">
          <mat-label>Fecha</mat-label>
          <input matInput [matDatepicker]="Paided" placeholder="" name="cobroCuotasCreditosConEmpleados.fecha" required
            [(ngModel)]="cobroCuotasCreditosConEmpleados.fecha" />
          <mat-datepicker-toggle matSuffix [for]="Paided"></mat-datepicker-toggle>
          <mat-datepicker #Paided></mat-datepicker>
          <mat-error *ngIf="invalidDate">Campo requerido</mat-error>
        </mat-form-field>
      </div>

      <div class="col-4">
        <app-input inputType="text" placeholder="Concepto" [isRequired]="true"
          [(ngModel)]="cobroCuotasCreditosConEmpleados.concepto"></app-input>
      </div>
      <div class="col-4"></div>

      <div class="col-4">
        <mat-form-field class="w-100 mt-2 mb-2">
          <mat-label>Importe Capital</mat-label>
          <input type="text" matInput placeholder="Importe Capital"
            [(ngModel)]="cobroCuotasCreditosConEmpleados.importeCapital"
            value="cobroCuotasCreditosConEmpleados.importeCapital" class="" required numberDecimalsDirective>
          <mat-error *ngIf="invalidImporteCapital">Campo requerido</mat-error>
        </mat-form-field>
      </div>

      <div class="col-4">
        <mat-form-field class="w-100 mt-2 mb-2">
          <mat-label>Intereses</mat-label>
          <input type="text" matInput placeholder="Intereses" [(ngModel)]="cobroCuotasCreditosConEmpleados.intereses"
            value="cobroCuotasCreditosConEmpleados.intereses" class="" numberDecimalsDirective>
          <mat-error *ngIf="invalidImporteCapital">Campo requerido</mat-error>
        </mat-form-field>
      </div>
      <div class="col-4"></div>

      <!-- Actividades -->
      <div class="col-4">
        <app-autocomplete-select [items]="activities" [(selectedItemId)]="cobroCuotasCreditosConEmpleados.activitiesUid"
          [idField]="'uid'" [displayField]="'name'" placeholder="Actividad">
        </app-autocomplete-select>
      </div>

      <div class="col-4">
        <app-autocomplete-select [items]="bankAccounts"
          [(selectedItemId)]="cobroCuotasCreditosConEmpleados.bankAccountsUid" [idField]="'uid'"
          [displayFields]="['bank', 'iban']" placeholder="Cuentas bancarias">
        </app-autocomplete-select>
      </div>

    </div>

    <div class="delete-info delete-info--success" *ngIf="depositSaved === true">
      <mat-icon>check_circle</mat-icon>
      <div class="delete-info__text">
        Cobro {{ isEditMode === true ? 'actualizado': 'añadido' }} correctamente
      </div>
    </div>

    <!-- Listado -->
    <ng-container *ngIf="list == true">
      <div class="dlg-empty-list">Listado</div>

      <app-table [columns]="headerTable" [dataSource]="dataSource" [hasSelect]="false" [hasButton]="true"
        [actionsTemplate]="actionsButtons">
      </app-table>

      <ng-template #actionsButtons let-uid="uid">
        <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
          <ul class="custom-class">
            <li (click)="edit(uid)">
              <a>
                <mat-icon>create</mat-icon> Editar
              </a>
            </li>
            <li (click)="delete(uid)">
              <a>
                <mat-icon>warning</mat-icon> Borrar
              </a>
            </li>
          </ul>
        </ng-container>
      </ng-template>
    </ng-container>

  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dlg-actions" *ngIf="depositSaved === false">
    <button mat-stroked-button (click)="closeDialog()">Cerrar</button>
    <button mat-flat-button class="dlg-btn-save" (click)="pay()">
      <mat-icon>save</mat-icon>
      {{ isEditMode === true ? 'Actualizar cobro' : 'Cobrar'}}
    </button>
  </mat-dialog-actions>

</ng-container>
